<!--
Author: TangChen
Date: 2018-09-22
Desc: 银行卡列表内容
-->
<template>
    <div class="comp-bank-lists comp">
        <el-dialog
            :title="title"
            :visible.sync="visible"
            class="prop"
            width="984px"
            v-on:close="dialogClose"
        >
            <div v-if="!isConfirm" class="bank-sel">
                <el-row v-if="bankLists.length > 0" :gutter="12" class="bank-msg">
                    <el-col v-for="(bank, index) in bankLists" :key="index" :span="6">
                        <div
                            v-if="icon === 'up' || index < 12"
                            class="bank-list"
                            v-on:click="selBank(bank.bankcode)"
                        >
                            <div class="bank-img">
                                <img :src="$util.getImg(bank.bankcode)" alt="" />
                                <span
                                    class="k-text-flow font-20 color-3d3d3d"
                                    :class="{
                                        fonts: bank.bankname.length >= 6
                                    }"
                                    :title="bank.bankname"
                                >
                                    {{ bank.bankname.toString().substr(0, 6) }}
                                </span>
                            </div>
                            <!--<p class="k-text-flow" :title="bank.bankinfo">{{bank.bankinfo}}</p>-->
                        </div>
                    </el-col>
                    <el-col v-if="bankLists.length > 12" :span="24" class="more">
                        <div v-on:click.prevent="icon = icon === 'down' ? 'up' : 'down'">
                            <i :class="'fa fa-chevron-' + icon" aria-hidden="true" />
                            更多银行
                        </div>
                    </el-col>
                </el-row>
                <div v-if="bankLists.length === 0 && !bankAuth" class="no-banks">暂无可用网点</div>
                <div v-if="bankLists.length === 0 && bankAuth" class="auth-no-banks">
                    <!-- <div class="code-contain">
                        <img
                            class="code-img"
                            :src="
                                $util.imgSrc({
                                    fileCode: $cache.getCompanyInfoParam('10106001')
                                })
                            "
                            alt=""
                            srcset=""
                        />
                    </div> -->
                    <div class="text-contain">
                        <!-- <p class="text1">无法验证，请扫码下载APP</p> -->
                        <p class="text1">您绑定的银行卡不支持验证，请联系人工客服。</p>
                        <!-- <p class="text2">您绑定的银行卡不支持验证，请下载基金APP，通过人脸识别</p>
                        <p class="text3">找回密码，或者联系人工客服。</p> -->
                    </div>
                    <div class="service-contain">
                        <div>
                            <img src="@/assets/img/service.png" />
                        </div>
                        <div class="service-text">
                            客服热线 ：{{ $cache.getCompanyInfoParam("10101009") }}
                        </div>
                    </div>
                    <div class="btn-contain">
                        <div class="btn-text" v-on:click="dialogClose">知道了</div>
                    </div>
                </div>
            </div>
            <div v-if="isConfirm" class="bank-confirm">
                <el-row v-if="channels.length > 0" :gutter="12" class="bank-msg">
                    <el-col v-for="(bank, index) in channels" :key="index" :span="6">
                        <div
                            class="bank-list"
                            :class="{
                                'is-active': selBankId === bank.channelid
                            }"
                            v-on:click="confirmBank(bank.channelid)"
                        >
                            <div class="bank-img">
                                <img :src="$util.getImg(bank.bankcode)" alt="" />
                                <span
                                    class="k-text-flow font-20 color-3d3d3d"
                                    :class="{
                                        fonts: bank.bankname.length >= 4
                                    }"
                                    :title="bank.bankname"
                                >
                                    {{ bank.paycentername }}
                                </span>
                            </div>
                            <!--<p class="k-text-flow">{{bank.bankinfo}}</p>-->
                            <i class="fa fa-check" aria-hidden="true" />
                        </div>
                    </el-col>
                    <el-col v-if="confirm[0]" :span="24" class="sel-bank-msg">
                        您已选择
                        <span class="color-1a1a1a">
                            {{
                                "【" +
                                confirm[0].bankname +
                                "(" +
                                confirm[0].paycentername +
                                "渠道)】"
                            }}
                        </span>
                        <!--显示鉴权方式-->
                        <span v-if="confirm[0].identifytype != 0">
                            ，{{
                                "该渠道是通过" +
                                identifyWay[
                                    bankAuth
                                        ? confirm[0].bankauthtype == 0
                                            ? confirm[0].identifytype
                                            : confirm[0].bankauthtype
                                        : confirm[0].identifytype
                                ] +
                                "。"
                            }}
                        </span>
                        <div class="bar-line"></div>
                        <div
                            v-cloak
                            v-if="confirm[0] && confirm[0].remark.trim() !== ''"
                            class="remark-con"
                        >
                            交易限额：{{ confirm[0].remark }}
                        </div>
                        <div
                            v-if="confirm[0] && confirm[0].discount.trim() !== ''"
                            :span="24"
                            class="discount-con"
                        >
                            {{ confirm[0].discount }}
                        </div>
                        <div v-if="confirm[0] && confirm[0].hint" :span="24" class="hint-con">
                            {{ confirm[0].hint }}
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-if="isConfirm" slot="footer" class="other dialog-footer">
                <div class="btn-box">
                    <el-button
                        v-if="bankLists.length !== 1"
                        class="back-btn"
                        v-on:click="isConfirm = false"
                    >
                        返回上一步
                    </el-button>
                    <el-button
                        type="primary"
                        :disabled="selBankId === -1"
                        class="confirm-btn"
                        v-on:click="back()"
                    >
                        确 定
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "BankLists",
    props: {
        bankVisible: {
            type: Boolean,
            required: true
        },
        url: {
            type: String,
            default: "acct/resettradepwd/banklist"
        },
        bankAuth: {
            type: Boolean,
            default: false
        },
        certType: {
            type: String,
            default: "00"
        },
        requiredBankCardList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false, // 是否显示dialog
            bankLists: [], // 展示的银行
            bankListsAll: [], // 所有的银行
            bankLists8: [], // 支持永居证的银行
            identifyWay: ["", "手机号码进行短信验证", "页面银行卡验证"],
            icon: "down",
            isConfirm: false,
            channels: [],
            confirm: [],
            title: "请选择所属银行",
            selBankId: -1 // 选中索引值
        };
    },
    watch: {
        bankVisible(val) {
            this.visible = val;
            if (val) {
                this.initSelBank();
            }
        },
        isConfirm(val) {
            this.title = val ? `请选择【${this.channels[0].bankname}】对应渠道` : "请选择所属银行";
            this.confirm = [];
        }
    },
    created() {
        this.initBank();
        this.visible = this.bankVisible;
    },
    methods: {
        /* 初始化银行卡信息 */
        initBank() {
            this.$util.getBankInfo(
                {
                    biztype2:
                        this.$route.name == "bindnewacct"
                            ? "open"
                            : this.$route.name == "tradepwd"
                            ? "exists"
                            : this.$route.name == "retrievepwd"
                            ? "open"
                            : "add-multi"
                },
                (res, res8) => {
                    this.bankListsAll = this.initBankFunc(res);
                    this.bankLists8 = this.initBankFunc(res8);
                    if (this.certType === "0B") {
                        this.bankLists = this.bankLists8;
                    } else {
                        this.bankLists = this.bankListsAll;
                    }

                    // 过滤出名下的卡
                    if (this.requiredBankCardList.length > 0) {
                        // 提取个人卡的 bankcode+paychannel 组合集合
                        const myBankKeys = new Set(
                            this.requiredBankCardList.map(
                                (card) => `${card.bankcode}_${card.paychannel}`
                            )
                        );
                        const filtered = [];
                        for (const bank of this.bankLists) {
                            if (!bank.child) continue;
                            const matchedChannels = bank.child.filter((channel) =>
                                myBankKeys.has(`${bank.bankcode}_${channel.paycenterid}`)
                            );
                            if (matchedChannels.length > 0) {
                                filtered.push({ ...bank, child: matchedChannels });
                            }
                        }
                        this.bankLists = filtered;
                    }
                    this.initSelBank();
                }
            );
        },
        initBankFunc(res) {
            let bank = [];
            if (this.bankAuth) {
                bank = [];
                res.forEach((item) => {
                    item.child = item.child.filter((childItem) => {
                        return childItem.businessflag.indexOf("9") > -1;
                    });
                    if (item.child.length > 0) {
                        bank.push(item);
                    }
                });
                if (bank.length == 0) {
                    this.title = "温馨提示";
                }
            } else {
                bank = res || [];
            }
            return bank;
        },
        initSelBank() {
            if (this.bankLists.length === 1) {
                this.selBank(this.bankLists[0].bankcode);
                this.isConfirm = true;
                this.title = this.isConfirm
                    ? `请选择【${this.channels[0].bankname}】对应渠道`
                    : "请选择所属银行";
            }
        },
        /* 关闭银行卡选择界面 */
        dialogClose(val) {
            this.isConfirm = false;
            this.confirm = [];
            this.$emit("bank-hide");
        },
        /* 选中银行卡 */
        selBank(val) {
            const selBank = this.bankLists.filter((bank) => {
                return bank.bankcode === val;
            });
            this.channels = selBank[0].child;
            this.isConfirm = true;
            this.selBankId = -1;
        },
        /* 确认选中银行卡网点 */
        confirmBank(val) {
            this.selBankId = val;
            this.confirm = this.channels.filter((bank) => {
                return bank.channelid === val;
            });
        },
        /* 传值给父组件 */
        back() {
            this.isConfirm = false;
            let _x = {};
            if (this.selBankId !== -1) {
                _x.bank = {};
                _x.bank = this.confirm[0];
            }
            this.$emit("bank-hide", _x);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-bank-lists .prop {
    .el-dialog__header,
    .el-dialog__body .other-bank {
        padding: 13px 24px;
        border-bottom: 2px solid $border-color3;
        font-size: $f16;
        .el-dialog__headerbtn {
            top: 13px;
        }
        .el-dialog__title {
            font-size: $f18;
        }
    }
    .el-dialog {
        border-radius: 4px 4px;
        width: 984px !important;
    }
    .el-dialog__body {
        text-align: left;
        padding: 30px 20px;
        .other-bank {
            margin-bottom: 15px;
        }
        .el-col {
            &.sel-bank-msg {
                border-radius: 6px;
                background: #f9f9f9;
                padding: 12px 20px !important;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                span {
                    color: $text-color2;
                    &.color-1a1a1a {
                        font-weight: 700;
                        color: #1a1a1a;
                    }
                }
                .bar-line {
                    margin-top: 12px;
                    position: relative;
                    right: 20px;
                    height: 1px;
                    background-color: #f1f1f1;
                    width: 956px;
                }
                .remark-con {
                    margin-top: 12px;
                    font-size: 18px;
                    font-weight: normal;
                    color: #ff7d00 !important;
                }
                .discount-con {
                    font-size: 16px;
                    font-weight: normal;
                    color: #666666 !important;
                    margin-top: 4px;
                }
                .hint-con {
                    font-size: 16px;
                    font-weight: normal;
                    color: var(--color-primary) !important;
                    margin-top: 4px;
                }
            }

            &.more {
                text-align: center;
                color: $color-b;
                div {
                    cursor: pointer;
                    display: inline-block;
                    i {
                        padding: 0 5px;
                    }
                }
            }
            margin-bottom: 16px;
            .bank-list {
                border: 1px solid #e4e4e4;
                border-radius: 2px;
                cursor: pointer;
                padding: 3px 15px 4px;
                position: relative;
                display: flex;
                &:hover,
                &.is-active {
                    border: 1px solid var(--color-primary);
                }
                .fa.fa-check {
                    font-size: $f12;
                    color: $text-color6;
                    position: absolute;
                    right: 1px;
                    bottom: 3px;
                    display: none;
                }
                &.is-active {
                    .fa.fa-check {
                        display: block;
                    }
                    &:before {
                        position: absolute;
                        right: -1px;
                        bottom: -1px;
                        content: "";
                        border: 15px solid var(--color-primary);
                        border-bottom-right-radius: 4px 4px;
                        border-top-color: transparent;
                        border-left-color: transparent;
                    }
                }
                .bank-img {
                    height: 34px;
                    span {
                        color: $text-color2;
                        font-size: $f18;
                        vertical-align: middle;
                        line-height: 30px;
                        margin-left: 4px;
                        &.fonts {
                            font-size: $f16;
                        }
                    }
                    i {
                        margin-top: 5px;
                        float: right;
                        line-height: 20px;
                    }
                }
                & > p {
                    color: $text-color3;
                    line-height: 22px;
                }
            }
        }
    }
    .el-dialog__footer {
        .btn-box {
            text-align: center;
            .back-btn {
                width: 180px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                color: #666666;
                border: none;
            }
            .confirm-btn {
                width: 180px;
                border-radius: 2px;
                background: var(--color-primary);
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
            }
        }
    }
    .font-20 {
        font-size: 20px;
        font-weight: 500;
    }
    .color-3d3d3d {
        color: #3d3d3d;
    }
    .auth-no-banks {
        .code-contain {
            width: 100%;
            text-align: center;
            .code-img {
                width: 180px;
                height: 180px;
            }
        }
        .text-contain {
            .text1 {
                text-align: center;
                font-size: 18px;
                color: #3d3d3d;
                font-weight: 600;
                padding: 20px 0 5px;
            }
            .text2 {
                text-align: center;
                padding: 5px 0 5px;
            }
            .text3 {
                text-align: center;
                padding: 5px 0 30px;
            }
        }
        .service-contain {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $bg18;
            // cursor: pointer;
            .service-text {
                padding-left: 5px;
            }
        }
        .btn-contain {
            text-align: center;
            font-size: 16px;
            display: flex;
            justify-content: center;
            margin-top: 25px;
            .btn-text {
                width: 190px;
                height: 44px;
                line-height: 44px;
                cursor: pointer;
                background-color: var(--color-primary);
                color: #ffffff;
            }
        }
    }
}
</style>
